<template>
  <form
    ref="formRef"
    class="mt-3"
    method="post"
    action="/gift/buy"
    @submit="submit($event)"
  >
    <CsrfField />

    <FormGroup :v="v$.value">
      <CartControl
        v-model="formValue.value"
        size="lg"
        variant="active"
        name="value"
        :title="$t('gift.label')"
        :min="5"
        :max="100"
        :step="5"
        :prefix="isPl ? undefined : '€'"
        :suffix="isPl ? (isEnglish ? 'PLN' : 'zł') : undefined"
        fix-overlimit
      />
    </FormGroup>

    <FormGroup :v="v$.paymentType">
      <RadioField
        v-for="paymentType of props.paymentTypes"
        :id="'payment-' + paymentType"
        :key="paymentType"
        v-model="formValue.paymentType"
        name="payment_type"
        :value="paymentType"
      >
        {{ $t("common.payment." + paymentType) }}
      </RadioField>
    </FormGroup>

    <AppButton type="submit">
      {{ $t("gift.pay") }}
    </AppButton>
  </form>
</template>

<script lang="ts" setup>
import AppButton from "@/components/app-button.vue";
import RadioField from "@/components/form/radio-field.vue";
import FormGroup from "@/components/form/form-group.vue";
import CartControl from "@/components/cart/cart-control.vue";
import { required } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import { ref, reactive, computed } from "vue";
import { useI18n } from "vue-i18n";
import { isLoggedIn, openLoginModal } from "../user/store";
import CsrfField from "@/components/form/csrf-field.vue";

const { locale } = useI18n();
const isPl = computed(() => window.mangasPortal === 'pl');
const isEnglish = computed(() => locale.value.toLowerCase().startsWith('en'));

const props = defineProps<{
  paymentTypes: string[];
}>();

const formRef = ref<HTMLFormElement>();

type GiftForm = {
  value: number;
  paymentType?: string;
};

const formValue = reactive<GiftForm>({
  value: 20,
  paymentType: undefined,
});

const rules = computed(
  (): Record<keyof GiftForm, any> => ({
    value: { required },
    paymentType: { required },
  })
);

const v$ = useVuelidate(rules, formValue);

const submit = async ($event: Event): Promise<void> => {
  v$.value.$touch();

  if (v$.value.$invalid) {
    $event.preventDefault();
  } else if (!isLoggedIn.value) {
    $event.preventDefault();
    const isLogged = await openLoginModal();
    if (isLogged) {
      formRef.value?.submit();
    }
  }
};
</script>
